export const getDataForBookingLink = (selectedBenefit, flat, currentData) => {
  const chooseGroup = key => {
    switch (key) {
      case 'cash':
        return (selectedBenefit?.guid && selectedBenefit.redPrice) ||
          (selectedBenefit?.guid && flat?.redPrice === false && selectedBenefit.redPrice === false)
          ? selectedBenefit?.guid
          : 'null';
      case 'mortgage':
        return selectedBenefit?.guid ? selectedBenefit.guid : 'null';
      default:
        return 'null';
    }
  };

  const data = {
    flatId: flat?.id,
    benefitGuid: chooseGroup(selectedBenefit?.group),
    loanTerm:
      selectedBenefit?.group === 'mortgage' && currentData?.currentLoanTerm ? currentData?.currentLoanTerm : null,
    firstPayment:
      selectedBenefit?.group === 'mortgage' && currentData?.currentFirstPayment
        ? currentData?.currentFirstPayment
        : null,
  };

  return data;
};
